(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("gateFiSDK", [], factory);
	else if(typeof exports === 'object')
		exports["gateFiSDK"] = factory();
	else
		root["gateFiSDK"] = factory();
})(this, () => {
return 